import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TelaSincronizarIfoodComponent } from '../../compartilhado/tela-sincronizar-ifood/tela-sincronizar-ifood.component';
import { TelaImportarProdutosERPComponent } from '../../compartilhado/tela-importarerp/tela-importar-produtos-erp.component';
import { TelaSincronizarChinaComponent } from '../../compartilhado/tela-sincronizar-china/tela-sincronizar-china.component';
import { TelaSincronizarCatalogomodeloComponent } from '../../compartilhado/tela-sincronizar-catalogomodelo/tela-sincronizar-catalogomodelo.component';
import { KendoPopupUtils } from '../../lib/KendoPopupUtils';
import { ConfirmacaoV2 } from '../confirmacao-v2';
import {temPublicacaoCatalogoIfoodHabilitada} from '../../canais-venda/canais-venda.logic';
import { OfertasBoasVindasComponent } from '../../compartilhado/ofertas-boas-vindas/ofertas-boas-vindas.component';
import { OrdenarCategoriasComponent } from '../../superadmin/ordenar-categorias/ordenar-categorias.component';
import { ImportadorCsvComponent } from '../../importador-csv/importador-csv.component';
import { ConstantsService } from '../../fidelidade/ConstantsService';
import { NotificationService } from '../../services/notification.service';
import { AutorizacaoService } from '../../services/autorizacao.service';
import { CardapioService } from '../../services/cardapio.service';
import { TelaImportarCatalogoEmpresaComponent } from '../../superadmin/produtos2/tela-importar-catalogo-empresa/tela-importar-catalogo-empresa.component';
import { ModalExportarProdutosComponent } from '../../compartilhado/modal-exportar-produtos/modal-exportar-produtos.component';
import { DisponibilidadeService } from '../../compartilhado/services/disponibilidade.service';
import { ViewDisponibilidadeComponent } from '../../compartilhado/view-disponibilidade/view-disponibilidade.component';
import { ProdutosV2FacadeService } from '../produtos-v2.facade';
import { ImportadorCodigosPdvV2Component } from '../importador-codigos-pdv-v2/importador-codigos-pdv-v2.component';
import {
  CatalogStatusTabKeyV2,
  CatalogStatusTabVM,
  CatalogSortFieldV2,
  CatalogSortDirectionV2,
  CatalogSortConfigV2,
  ProductEditorGroupDraftModeV2,
  ProductEditorSurfaceV2,
  ProductCatalogItemVM,
  ProductCatalogViewModeV2,
  ProductTypeV2,
  ReorderActionV2
} from '../produtos-v2.models';

type CatalogTopActionId = 'new-normal' | 'new-brinde' | 'template-pizza' | 'sort-name' | 'price-tables' | 'import' | 'export' | 'advanced';
type ProductEditorOptionModeV2 = 'review' | 'activation' | 'batch-price';
type CatalogAvailabilityTargetV2 = 'selection' | 'category';
type CatalogImporterId =
  | 'cardapio-ia'
  | 'network-store'
  | 'catalog-model'
  | 'open-delivery'
  | 'erp-new'
  | 'erp-code'
  | 'chinainbox'
  | 'gendai'
  | 'ifood'
  | '99food'
  | 'sistema-externo'
  | 'csv'
  | 'csv-prices'
  | 'pdv-codes';

interface CatalogImporterOptionVM {
  id: CatalogImporterId;
  label: string;
  description: string;
  icon: string;
  destaque?: boolean;
  badge?: string;
}

interface CatalogImporterGroupVM {
  title: string;
  items: CatalogImporterOptionVM[];
}

@Component({
  selector: 'app-tela-catalogo-produtos-v2',
  templateUrl: './tela-catalogo-produtos-v2.component.html',
  styleUrls: ['./tela-catalogo-produtos-v2.component.scss']
})
export class TelaCatalogoProdutosV2Component implements OnInit, OnDestroy {
  private static readonly BODY_DRAWER_CLASS = 'pv2-drawer-open';
  private readonly destroy$ = new Subject<void>();
  empresa: any;
  isMobile = false;
  loading = true;
  search = '';
  searchFocused = false;
  selectedCategory = 'Todos';
  selectedStatusTab: CatalogStatusTabKeyV2 = 'sale';
  items: ProductCatalogItemVM[] = [];
  editingPriceId: number | null = null;
  editingPriceValue = '';
  savingPriceId: number | null = null;
  actionItem: ProductCatalogItemVM | null = null;
  actionSheetOpen = false;
  moveCategoryItem: ProductCatalogItemVM | null = null;
  createChooserOpen = false;
  importChooserOpen = false;
  exportChooserOpen = false;
  moreActionsOpen = false;
  categorySheetOpen = false;
  reorderFromSheet = false;
  categorySheetSearch = '';
  categorySheetSelected = 'Todos';
  readonly maxVisibleCategoryChips = 6;
  bulkMode = false;
  bulkSelection: Record<number, boolean> = {};
  bulkCategoryId = '';
  bulkActionBusy = false;
  bulkDeleteDialogOpen = false;
  readonly confirmacao = new ConfirmacaoV2();
  duplicatingId: number | null = null;
  bulkAvailabilityDialogOpen = false;
  bulkAvailabilitySaving = false;
  bulkAvailabilityTarget: CatalogAvailabilityTargetV2 = 'selection';
  bulkAvailabilityCategory: { id: number | null; nome: string } | null = null;
  bulkAvailabilityForm: any = { disponibilidade: 0, disponibilidades: [] };
  readonly bulkAvailabilityOptions = [
    { id: 0, descricao: 'Sempre disponível' },
    { id: 1, descricao: 'Disponível em dias específicos' },
    { id: 2, descricao: 'Não disponível' }
  ];
  pizzaTemplates: any[] = [];
  usuario: any = {};
  viewMode: ProductCatalogViewModeV2 = (sessionStorage.getItem('produtos-v2-view-mode') as ProductCatalogViewModeV2) || 'grid';
  isReorderMode = false;
  reorderDraft: ProductCatalogItemVM[] = [];
  lastMovedIds = new Set<number>();
  lastSwappedId: number | null = null;
  lastMoveDirection: 'up' | 'down' | null = null;
  private lastMovedTimer: any = null;
  advancedFiltersOpen = false;
  appliedFilters = {
    sortField: 'ordem' as 'name' | 'price' | 'ordem',
    sortDirection: 'asc' as 'asc' | 'desc',
    semCodigoPdv: false,
    naoSincronizados: false,
    disponibilidadeIds: [] as any[]
  };
  filterDraft = { ...this.appliedFilters, disponibilidadeIds: [] as any[] };
  gridSortOptions = [
    { text: 'Nome', value: 'name' },
    { text: 'Preço', value: 'price' },
    { text: 'Mais recentes', value: 'created' }
  ];
  gridSortField: CatalogSortFieldV2 = 'name';
  gridSortDirection: CatalogSortDirectionV2 = 'asc';
  disponibilidadesCatalogo: any[] = [];
  drawerOpen = false;
  drawerProductId: number | null = null;
  drawerNewProductType: ProductTypeV2 | null = null;
  drawerInitialCategoryId: number | null = null;
  drawerCreationSeed = 0;
  drawerPizzaTemplateId: number | null = null;
  drawerSurface: ProductEditorSurfaceV2 = 'overview';
  drawerFocusGroupId: number | string | null = null;
  drawerGroupDraftMode: ProductEditorGroupDraftModeV2 | null = null;
  drawerOptionMode: ProductEditorOptionModeV2 | null = null;
  drawerCrossSellProductId: number | null = null;
  drawerStartWithPreview = false;
  drawerStartWithLibrary = false;
  drawerHasCommittedChanges = false;
  drawerScrollToSection: string | null = null;
  private drawerOverviewScrollTop = 0;
  private failedImageIds = new Set<number>();
  showProductPhotos = true;
  savingProductPhotosPreference = false;
  temModuloTabelaPrecos = false;
  @ViewChild('viewDisponibilidadesV2', { static: false }) viewDisponibilidadesV2: ViewDisponibilidadeComponent;
  readonly primaryDesktopActions:
    Array<{ id: CatalogTopActionId; label: string; icon: string; tone: 'green' | 'orange' | 'blue' | 'neutral' }> = [
    { id: 'new-normal', label: 'Novo Produto', icon: 'fa-plus', tone: 'green' },
    { id: 'new-brinde', label: 'Novo Brinde', icon: 'fa-gift', tone: 'orange' },
    { id: 'template-pizza', label: 'Template Pizzas', icon: 'fa-globe', tone: 'blue' },
    { id: 'sort-name', label: 'Ordenar por nome', icon: 'fa-sort-alpha-asc', tone: 'neutral' },
    { id: 'import', label: 'Importar', icon: 'fa-upload', tone: 'neutral' },
    { id: 'export', label: 'Exportar', icon: 'fa-download', tone: 'neutral' },
    { id: 'advanced', label: 'Ferramentas avançadas', icon: 'fa-external-link', tone: 'neutral' }
  ];

  readonly desktopSecondaryActions: Array<{ id: CatalogTopActionId; label: string; icon: string }> = [
    { id: 'new-brinde', label: 'Novo Brinde', icon: 'fa-gift' },
    { id: 'template-pizza', label: 'Template Pizzas', icon: 'fa-globe' },
    { id: 'sort-name', label: 'Ordenar por nome', icon: 'fa-sort-alpha-asc' },
    { id: 'advanced', label: 'Ferramentas avançadas', icon: 'fa-external-link' }
  ];

  desktopActionsDropdownOpen = false;
  exportDropdownOpen = false;

  readonly mobileSecondaryActions: Array<{
    id: CatalogTopActionId;
    label: string;
    icon: string;
    description: string;
    tone: 'blue' | 'green' | 'orange' | 'neutral' | 'brinde';
  }> = [
    {
      id: 'new-brinde',
      label: 'Novo Brinde',
      icon: 'fa-gift',
      description: 'Crie um item resgatavel com pontos',
      tone: 'brinde'
    },
    {
      id: 'template-pizza',
      label: 'Template Pizzas',
      icon: 'fa-globe',
      description: 'Abra uma estrutura pronta para sabores',
      tone: 'orange'
    },
    {
      id: 'sort-name',
      label: 'Ordenar por nome',
      icon: 'fa-sort-alpha-asc',
      description: 'Alterna a ordem alfabetica da listagem',
      tone: 'neutral'
    },
    {
      id: 'price-tables',
      label: 'Tabelas preços',
      icon: 'fa-tags',
      description: 'Cadastre regras de preço por canal.',
      tone: 'neutral'
    },
    {
      id: 'import',
      label: 'Importar',
      icon: 'fa-upload',
      description: 'Use os importadores existentes do catalogo',
      tone: 'blue'
    },
    {
      id: 'export',
      label: 'Exportar',
      icon: 'fa-download',
      description: 'Baixe o catalogo atual para uso externo',
      tone: 'green'
    },
    {
      id: 'advanced',
      label: 'Ferramentas avançadas',
      icon: 'fa-external-link',
      description: 'Acesse recursos extras do catalogo',
      tone: 'neutral'
    }
  ];

  constructor(
    private constantsService: ConstantsService,
    private facade: ProdutosV2FacadeService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialogService: DialogService,
    private notificationService: NotificationService,
    private autorizacaoService: AutorizacaoService,
    private cardapioService: CardapioService,
    private disponibilidadeService: DisponibilidadeService
  ) {
    this.handleResize();
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        this.syncDrawerFromRoute(params);
        // primeiros passos do onboarding: "Trazer do iFood ou de outra plataforma" abre direto a escolha do importador
        if (params?.abrir === 'importadores' && !this.importChooserOpen) setTimeout(() => this.abraImportadores(), 0);
      });

    this.autorizacaoService.fetchUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((usuario) => {
        this.usuario = usuario || {};
      });

    this.constantsService.empresa$
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (empresa) => {
        if (!empresa?.catalogo?.id) return;
        this.empresa = empresa;
        this.showProductPhotos = this.resolveShowProductPhotosPreference(empresa?.cardapio);
        this.disponibilidadesCatalogo = this.disponibilidadeService.obtenhaDisponibidadesComDescricao(
          empresa.catalogo?.disponibilidades || []
        );
        await this.recarregue();
      });

    this.constantsService.moduloTabelaPrecos$
      .pipe(takeUntil(this.destroy$))
      .subscribe((ativo) => {
        this.temModuloTabelaPrecos = !!ativo;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    document.body.classList.remove(TelaCatalogoProdutosV2Component.BODY_DRAWER_CLASS);
  }

  abraTabelaPrecos(): void {

    this.fecheMaisAcoes();
    this.closeDesktopActionsDropdown();
    this.closeExportDropdown();

    this.router.navigateByUrl('/admin/tabelas-precos').then( () => {
    });
  }

  abraCanaisVenda(): void {
    this.fecheMaisAcoes();
    this.closeDesktopActionsDropdown();
    this.closeExportDropdown();
    this.router.navigateByUrl('/admin/canais-venda/publicar-produtos').then(() => {});
  }

  get publicacaoCatalogoIfoodHabilitada(): boolean {
    return temPublicacaoCatalogoIfoodHabilitada(this.empresa);
  }

  fecheTabelaPrecos(): void {

  }

  @HostListener('window:resize')
  handleResize() {
    this.isMobile = window.innerWidth < 1024;
    if (this.isMobile) {
      this.viewMode = 'list';
    }

    this.syncViewportLock();
  }

  statusTabs: CatalogStatusTabVM[] = [];
  statusFilteredItems: ProductCatalogItemVM[] = [];
  categoryList: Array<{ nome: string; id: number | null; count: number; emoji: string }> = [];
  filteredItems: ProductCatalogItemVM[] = [];

  get importerGroups(): CatalogImporterGroupVM[] {
    const groups: CatalogImporterGroupVM[] = [];
    const redeItems: CatalogImporterOptionVM[] = [];
    const integracaoItems: CatalogImporterOptionVM[] = [];

    groups.push({
      title: 'Importar cardápio',
      items: [
        {
          id: 'cardapio-ia',
          label: 'Foto ou PDF',
          description: 'A IA lê o arquivo e você revisa antes de importar.',
          icon: 'fa-magic',
          destaque: true,
          badge: 'Com IA'
        },
        {
          id: 'sistema-externo',
          label: 'Link de outra plataforma',
          description: 'Cole o link do iFood, Anota Aí, OlaClick ou outra plataforma.',
          icon: 'fa-globe'
        },
        {
          id: 'csv',
          label: 'Arquivo CSV',
          description: 'Cria ou atualiza produtos a partir de um arquivo CSV.',
          icon: 'fa-file-alt'
        }
      ]
    });

    if (this.canImportFromAnotherStore()) {
      redeItems.push({
        id: 'network-store',
        label: 'Outra loja da rede',
        description: `Copie o cardápio de uma loja da rede ${this.getNomeRede()}.`,
        icon: 'fa-sitemap'
      });
    }

    if (this.canSyncCatalogModel()) {
      redeItems.push({
        id: 'catalog-model',
        label: 'Catálogo modelo',
        description: `Usa "${this.empresa?.modeloCatalogoDaRede?.catalogo?.nome || 'catalogo modelo'}" como origem.`,
        icon: 'fa-object-group'
      });
    }

    if (this.canImportOpenDelivery()) {
      integracaoItems.push({
        id: 'open-delivery',
        label: `Importar ${this.empresa?.integracaoOpendelivery?.merchantName || 'Open Delivery'}`,
        description: 'Busca produtos da integracao Open Delivery ativa.',
        icon: 'fa-plug'
      });
    }

    if (this.canSyncWithPartners()) {
      integracaoItems.push(
        {
          id: 'erp-new',
          label: 'Novos produtos do parceiro',
          description: `Importa produtos novos vindos do ${this.getPartnerSystemLabel()}.`,
          icon: 'fa-cloud-download'
        },
        {
          id: 'erp-code',
          label: 'Produto por código',
          description: `Busque um item específico no ${this.getPartnerSystemLabel()}.`,
          icon: 'fa-barcode'
        }
      );
    }

    if (this.canImportChinaInBox()) {
      integracaoItems.push({
        id: 'chinainbox',
        label: 'China In Box',
        description: 'Importe o cardápio da unidade pela localização da loja.',
        icon: 'fa-globe'
      });
    }

    if (this.canImportGendai()) {
      integracaoItems.push({
        id: 'gendai',
        label: 'Gendai',
        description: 'Usa o importador da rede Gendai.',
        icon: 'fa-globe'
      });
    }

    if (this.canImportIfood()) {
      integracaoItems.push({
        id: 'ifood',
        label: 'Importar do iFood',
        description: 'Busca produtos e adicionais da integração iFood ativa.',
        icon: 'fa-utensils'
      });
    }

    if (this.canImportFood99()) {
      integracaoItems.push({
        id: '99food',
        label: 'Importar do 99Food',
        description: 'Busca produtos e adicionais da integração 99Food ativa.',
        icon: 'fa-utensils'
      });
    }

    if (redeItems.length || integracaoItems.length) {
      groups.push({
        title: 'Lojas e integrações',
        items: [...redeItems, ...integracaoItems]
      });
    }

    groups.push({
      title: 'Atualizar dados',
      items: [
        {
          id: 'csv-prices',
          label: 'Preços via CSV',
          description: 'Altere apenas os preços com um arquivo CSV.',
          icon: 'fa-money-bill-alt'
        },
        {
          id: 'pdv-codes',
          label: 'Códigos PDV em lote',
          description: 'Cole uma planilha simples para atualizar produtos e adicionais.',
          icon: 'fa-barcode'
        }
      ]
    });

    return groups;
  }

  private refreshCachedLists() {
    const activeCount = this.items.filter((item) => item.status === 'active').length;
    const unavailableCount = this.items.filter((item) => item.status === 'draft').length;

    this.statusTabs = [
      { key: 'sale', label: 'À venda', count: activeCount },
      { key: 'unavailable', label: 'Indisponíveis', count: unavailableCount },
      { key: 'stock', label: 'Reposição estoque', count: 0, disabled: true }
    ];

    if (this.selectedStatusTab === 'unavailable') {
      this.statusFilteredItems = this.items.filter((item) => item.status === 'draft');
    } else if (this.selectedStatusTab === 'stock') {
      this.statusFilteredItems = [];
    } else {
      this.statusFilteredItems = this.items.filter((item) => item.status === 'active');
    }

    const counts = new Map<string, { nome: string; id: number | null; count: number; emoji: string }>();
    this.statusFilteredItems.forEach((item) => {
      const key = item.category || 'Sem categoria';
      const existing = counts.get(key) || {
        nome: key,
        id: item.categoryId,
        count: 0,
        emoji: item.placeholderToken || '🍽️'
      };
      existing.count += 1;
      counts.set(key, existing);
    });

    const categoriasCatalogo = (this.empresa?.catalogo?.categorias || []).map((categoria: any) => {
      const existing = counts.get(categoria.nome);
      return {
        nome: categoria.nome,
        id: categoria.id,
        count: existing?.count || 0,
        emoji: this.resolveCategoryEmoji(categoria.nome)
      };
    });

    this.categoryList = [
      { nome: 'Todos', id: null, count: this.statusFilteredItems.length, emoji: '📋' },
      ...categoriasCatalogo,
      ...Array.from(counts.values())
        .filter((categoria) => !categoriasCatalogo.find((item) => item.id === categoria.id))
        .sort((a, b) => a.nome.localeCompare(b.nome))
    ];

    const term = this.normalizeSearchTerm(this.search);
    const selectedCategory = this.selectedCategory;
    let filtered = this.statusFilteredItems.filter((item) => {
      const matchCategory = selectedCategory === 'Todos' || item.category === selectedCategory;
      const matchTerm = !term
        || this.normalizeSearchTerm(item.name).includes(term)
        || this.normalizeSearchTerm(item.category).includes(term)
        || this.normalizeSearchTerm(item.description || '').includes(term)
        || this.matchesPriceSearch(item.basePrice, term);

      return matchCategory && matchTerm;
    });

    if (this.appliedFilters.semCodigoPdv) {
      filtered = filtered.filter(item => !item.raw?.codigoPdv);
    }

    if (this.appliedFilters.naoSincronizados) {
      filtered = filtered.filter(item => !!item.raw?.naoSincronizar);
    }

    if (this.appliedFilters.disponibilidadeIds.length > 0) {
      const targetIds = new Set(this.appliedFilters.disponibilidadeIds.map((d: any) => d.id));
      filtered = filtered.filter(item => {
        const disps: any[] = item.raw?.disponibilidades || [];
        return disps.some((disp: any) => targetIds.has(disp.id));
      });
    }

    this.filteredItems = filtered.sort((a, b) => {
      if (this.appliedFilters.sortField === 'price') {
        const diff = a.basePrice - b.basePrice;
        return this.appliedFilters.sortDirection === 'asc' ? diff : -diff;
      }
      if (this.appliedFilters.sortField === 'name') {
        const compare = a.name.localeCompare(b.name, 'pt-BR');
        return this.appliedFilters.sortDirection === 'asc' ? compare : compare * -1;
      }
      // Ordenação manual (ordem)
      return (a.ordem_exibicao ?? 0) - (b.ordem_exibicao ?? 0);
    });
  }

  get selectedIds(): number[] {
    return Object.keys(this.bulkSelection)
      .filter((id) => this.bulkSelection[Number(id)])
      .map((id) => Number(id));
  }

  get disponibilidadePorEmpresa(): boolean {
    return !!this.empresa?.catalogo?.disponibilidadePorEmpresa;
  }

  get podeEditarProdutos(): boolean {
    return !this.empresa?.id || !this.empresa?.catalogo?.compartilhado;
  }

  get podeAlterarDisponibilidade(): boolean {
    return this.podeEditarProdutos || this.disponibilidadePorEmpresa;
  }

  get bulkPauseLabel(): string {
    return this.selectedStatusTab === 'unavailable' ? 'Despausar' : 'Pausar';
  }

  get bulkPauseIcon(): string {
    return this.selectedStatusTab === 'unavailable' ? 'fa-play-circle' : 'fa-pause-circle';
  }

  get bulkPauseTone(): string {
    return this.selectedStatusTab === 'unavailable' ? 'is-success' : 'is-warning';
  }

  get categoriaSelecionadaAtual(): { id: number | null; nome: string } | null {
    if (this.selectedCategory === 'Todos') return null;
    return this.categoryList.find((category) => category.nome === this.selectedCategory) || null;
  }

  get podeAlterarDisponibilidadeCategoria(): boolean {
    const categoria = this.categoriaSelecionadaAtual;
    return !!categoria?.id && this.podeAlterarDisponibilidade;
  }

  get todosProdutosVisiveisSelecionados(): boolean {
    return this.filteredItems.length > 0
      && this.filteredItems.every((item) => item.id != null && !!this.bulkSelection[item.id]);
  }

  async recarregue(options?: { silent?: boolean }) {
    if (!options?.silent) {
      this.loading = true;
    }
    try {
      const [nextItems, templates] = await Promise.all([
        this.facade.carregueCatalogo(this.empresa),
        this.facade.carregueTemplates(this.empresa.catalogo)
      ]);
      this.pizzaTemplates = templates || [];
      this.items = this.mergeCatalogItems(nextItems);
      for (const item of this.items) {
        if (item.id != null && this.failedImageIds.has(item.id)) {
          item.hasValidImage = false;
        }
        this.precomputeItemFlags(item);
      }
      this.refreshCachedLists();
      this.ensureValidFilters();
    } finally {
      if (!options?.silent) {
        this.loading = false;
      }
    }
  }

  selectStatusTab(tab: CatalogStatusTabVM | undefined) {
    if (!tab) {
      return;
    }

    if (tab.disabled) {
      this.notificationService.showError('Reposição de estoque ainda não está disponível na V2.');
      return;
    }

    this.selectedStatusTab = tab.key;
    this.refreshCachedLists();
    this.ensureValidFilters();
  }

  onSearchChanged() {
    this.refreshCachedLists();
  }

  selecioneCategoria(nome: string) {
    this.selectedCategory = nome;
    this.refreshCachedLists();
  }

  altereModoVisualizacao(modo: ProductCatalogViewModeV2) {
    if (this.isMobile) return;
    this.viewMode = modo;
    sessionStorage.setItem('produtos-v2-view-mode', modo);
  }

  async toggleProductPhotos() {
    if (!this.empresa?.id || this.savingProductPhotosPreference) {
      return;
    }

    const previousValue = this.showProductPhotos;
    const nextValue = !previousValue;
    const currentCardapio = this.empresa?.cardapio || {};
    const updatedCardapio = {
      ...currentCardapio,
      exibirFotosProdutosGestao: nextValue
    };

    this.showProductPhotos = nextValue;
    this.savingProductPhotosPreference = true;

    try {
      const savedCardapio = await this.cardapioService.atualizeConfiguracoesCardapio(updatedCardapio);
      const empresaAtualizada = {
        ...this.empresa,
        cardapio: {
          ...updatedCardapio,
          ...(savedCardapio || {})
        }
      };

      this.empresa = empresaAtualizada;
      this.constantsService.mudouEmpresa(empresaAtualizada);
      this.notificationService.showSuccess(nextValue ? 'Fotos dos produtos exibidas.' : 'Fotos dos produtos ocultadas.');
    } catch (error: any) {
      this.showProductPhotos = previousValue;
      this.notificationService.showError(error?.message || 'Não foi possível salvar a configuração de fotos.');
    } finally {
      this.savingProductPhotosPreference = false;
    }
  }

  // A configuracao completa (exibir, conteudo e formato) tambem vive na tela de
  // Vitrines, que e gateada pelo recurso `vitrines`. Este dialog e o mesmo controle
  // acessivel a quem nao tem esse recurso — o destaque e ligado por padrao p/ todos.
  abraOfertasBoasVindas() {
    if (!this.empresa?.id) {
      return;
    }

    this.fecheMaisAcoes();
    this.closeDesktopActionsDropdown();
    this.closeExportDropdown();

    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: OfertasBoasVindasComponent,
      minWidth: 320,
      width: window.innerWidth > 900 ? 900 : window.innerWidth,
      maxHeight: window.innerHeight - 80
    });

    const tela: OfertasBoasVindasComponent = windowRef.content.instance;

    tela.windowRef = windowRef;
    tela.empresa = this.empresa;
    // a previa mostra as ofertas reais desta loja, entao vai a lista ja carregada
    tela.produtos = (this.items || []).map((item) => item.raw).filter((produto) => !!produto);

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef);
    windowRef.result.subscribe(() => { });
  }

  toggleDesktopActionsDropdown() {
    this.closeExportDropdown();
    this.desktopActionsDropdownOpen = !this.desktopActionsDropdownOpen;
  }

  closeDesktopActionsDropdown() {
    this.desktopActionsDropdownOpen = false;
    this.exportDropdownOpen = false;
  }

  toggleExportDropdown() {
    this.exportDropdownOpen = !this.exportDropdownOpen;
  }

  closeExportDropdown() {
    this.exportDropdownOpen = false;
  }

  executeTopAction(actionId: CatalogTopActionId) {
    this.moreActionsOpen = false;
    this.desktopActionsDropdownOpen = false;
    this.exportDropdownOpen = false;

    if (actionId === 'new-normal') {
      this.crieProduto('normal');
      return;
    }

    if (actionId === 'new-brinde') {
      this.crieProduto('brindefidelidade');
      return;
    }

    if (actionId === 'sort-name') {
      this.toggleSortDirection();
      return;
    }

    if (actionId === 'price-tables') {
      this.abraTabelaPrecos();
      return;
    }

    if (actionId === 'import') {
      this.abraImportadores();
      return;
    }

    if (actionId === 'export') {
      this.abraExportadores();
      return;
    }

    this.openLegacyTools();
  }

  abraCriacao() {
    this.createChooserOpen = true;
    this.closeDesktopActionsDropdown();
    this.closeExportDropdown();
    this.closeActionSheet();
    this.importChooserOpen = false;
    this.exportChooserOpen = false;
    this.moreActionsOpen = false;
    this.syncViewportLock();
  }

  fecheCriacao() {
    this.createChooserOpen = false;
    this.syncViewportLock();
  }

  abraCategorias() {
    this.openLegacyImportModal({
      content: OrdenarCategoriasComponent,
      width: 600,
      setup: (instance) => {
        instance.catalogo = this.empresa?.catalogo;
        instance.empresa = this.empresa;
      },
      shouldRefresh: (result) => !!(result && result.length)
    });
  }

  abraCategoriasAtalho() {
    this.closeDesktopActionsDropdown();
    this.closeExportDropdown();
    this.fecheMaisAcoes();
    this.fecheCriacao();
    this.fecheImportadores();
    this.abraCategorias();
  }

  abraImportadores() {
    this.importChooserOpen = true;
    this.closeDesktopActionsDropdown();
    this.closeExportDropdown();
    this.closeActionSheet();
    this.createChooserOpen = false;
    this.exportChooserOpen = false;
    this.moreActionsOpen = false;
    this.syncViewportLock();
  }

  fecheImportadores() {
    this.importChooserOpen = false;
    this.syncViewportLock();
  }

  abraExportadores() {
    this.exportChooserOpen = true;
    this.closeDesktopActionsDropdown();
    this.closeExportDropdown();
    this.closeActionSheet();
    this.createChooserOpen = false;
    this.importChooserOpen = false;
    this.moreActionsOpen = false;
    this.syncViewportLock();
  }

  fecheExportadores() {
    this.exportChooserOpen = false;
    this.syncViewportLock();
  }

  abraMaisAcoes() {
    this.moreActionsOpen = true;
    this.closeDesktopActionsDropdown();
    this.closeExportDropdown();
    this.closeActionSheet();
    this.createChooserOpen = false;
    this.importChooserOpen = false;
    this.exportChooserOpen = false;
    this.syncViewportLock();
  }

  fecheMaisAcoes() {
    this.moreActionsOpen = false;
    this.syncViewportLock();
  }

  crieProduto(tipo: ProductTypeV2, pizzaTemplateId?: number | null) {
    this.createChooserOpen = false;
    this.syncViewportLock();
    this.drawerPizzaTemplateId = pizzaTemplateId ?? null;
    this.openProductDrawer({ newProductType: tipo, initialCategoryId: this.categoriaSelecionadaAtual?.id ?? null });
  }

  abraImportador(importadorId: CatalogImporterId) {
    this.fecheImportadores();

    switch (importadorId) {
      case 'cardapio-ia':
        this.router.navigate(['/admin/produtos-v2/importar-ia'], {
          queryParams: {voltarPara: this.router.url || '/admin/produtos-v2'}
        });
        return;
      case 'network-store':
        this.abrirImportarCatalogoEmpresaRede();
        return;
      case 'catalog-model':
        this.importarProdutosCatalogoModelo();
        return;
      case 'open-delivery':
        this.importarOpenDelivery();
        return;
      case 'erp-new':
        this.importarProdutosERP();
        return;
      case 'erp-code':
        this.importarProdutoCodigoERP();
        return;
      case 'chinainbox':
        this.importarProdutosChinaInBox();
        return;
      case 'gendai':
        this.importarProdutosChinna();
        return;
      case 'ifood':
        this.importarDoIfoodOficial();
        return;
      case '99food':
        this.importarDoFood99Oficial();
        return;
      case 'sistema-externo':
        this.importarDeSistemaExterno();
        return;
      case 'csv':
        this.importarDeArquivoCSV();
        return;
      case 'csv-prices':
        this.importarDeArquivoPrecosCSV();
        return;
      case 'pdv-codes':
        this.abrirImportadorCodigosPdv();
        return;
      default:
        return;
    }
  }

  abraEditor(item: ProductCatalogItemVM, extras: any = {}) {
    if (this.editingPriceId === item.id) return;
    this.actionSheetOpen = false;
    this.actionItem = null;
    this.openProductDrawer({
      productId: item.id,
      surfaceMode: 'overview',
      startWithLibrary: !!extras.library,
      startWithPreview: !!extras.preview
    });
  }

  abraTabelaPrecosProduto(item: ProductCatalogItemVM) {
    if (this.editingPriceId === item.id) return;
    this.actionSheetOpen = false;
    this.actionItem = null;
    this.openProductDrawer({
      productId: item.id,
      surfaceMode: 'overview',
      scrollToSection: 'tabela-precos'
    });
  }

  onProductCardPressed(item: ProductCatalogItemVM, event?: Event) {
    if (this.isReorderMode) return;

    if (this.bulkMode) {
      this.toggleBulkItem(item, event);
      return;
    }

    if (this.editingPriceId === item.id) {
      if (event) event.stopPropagation();
      return;
    }

    if (this.isMobile) {
      this.abraAcoes(item, event);
      return;
    }

    this.abraEditor(item);
  }

  abraComplementos(item: ProductCatalogItemVM, event?: Event) {
    if (event) {
      event.stopPropagation();
    }

    this.closeActionSheet();
    this.openProductDrawer({
      productId: item.id,
      surfaceMode: 'overview',
      scrollToSection: 'adicionais'
    });
  }

  abraFotos(item: ProductCatalogItemVM, event?: Event) {
    if (event) event.stopPropagation();
    if (this.bulkMode || this.isReorderMode) {
      this.onProductCardPressed(item, event);
      return;
    }

    this.closeActionSheet();
    this.openProductDrawer({
      productId: item.id,
      surfaceMode: 'overview',
      scrollToSection: 'fotos'
    });
  }

  getComplementsLabel(item: ProductCatalogItemVM): string {
    if (!item.groupCount) {
      return 'Adicionar';
    }

    return item.groupCount === 1 ? 'Grupo' : 'Grupos';
  }

  abraAcoes(item: ProductCatalogItemVM, event?: Event) {
    if (event) event.stopPropagation();
    this.moreActionsOpen = false;
    this.actionItem = item;
    this.actionSheetOpen = true;
    this.syncViewportLock();
  }

  closeActionSheet() {
    this.actionSheetOpen = false;
    this.actionItem = null;
    this.syncViewportLock();
  }

  abraMoverCategoria(item: ProductCatalogItemVM) {
    this.moveCategoryItem = item;
    this.closeActionSheet();
    this.syncViewportLock();
  }

  fecheMoverCategoria() {
    this.moveCategoryItem = null;
    this.syncViewportLock();
  }

  editePreco(item: ProductCatalogItemVM, event?: Event) {
    if (event) event.stopPropagation();
    if (!this.canEditInlinePrice(item)) return;
    this.editingPriceId = item.id;
    this.editingPriceValue = this.formatMoneyInput(item.basePrice);
    setTimeout(() => {
      const input = document.querySelector('.pv2-price-input') as HTMLInputElement;
      if (input) {
        input.focus();
        input.select();
      }
    });
  }

  async confirmePreco(item: ProductCatalogItemVM) {
    if (this.editingPriceId !== item.id) return;
    const valor = this.parseMoney(this.editingPriceValue);
    if (valor === item.basePrice) {
      this.editingPriceId = null;
      return;
    }
    this.savingPriceId = item.id;
    try {
      await this.facade.salvePrecoRapido(this.empresa, item, valor);
      item.basePrice = valor;
      this.notificationService.showSuccess('Preço atualizado.');
    } catch (error: any) {
      this.notificationService.showError(error?.message || 'Não foi possível atualizar o preço.');
    } finally {
      this.savingPriceId = null;
      this.editingPriceId = null;
    }
  }

  cancelePreco() {
    this.editingPriceId = null;
  }

  canEditInlinePrice(item: ProductCatalogItemVM): boolean {
    return item.type !== 'pizza' && !item.hasStartingPrice;
  }

  getCatalogPriceValue(item: ProductCatalogItemVM): string {
    return `R$ ${item.basePrice.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  }

  getCatalogPriceLabel(item: ProductCatalogItemVM): string {
    const prefix = item.hasStartingPrice ? 'A partir de R$ ' : 'R$ ';
    return `${prefix}${item.basePrice.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  }

  getCatalogStartingPriceEyebrow(item: ProductCatalogItemVM): string {
    return item.hasStartingPrice ? 'a partir de' : '';
  }

  onImageError(item: ProductCatalogItemVM, event?: Event) {
    if (event) {
      event.stopPropagation();
    }

    const nextCandidateIndex = (item.imageCandidateIndex ?? 0) + 1;
    const nextCandidate = item.imageCandidates?.[nextCandidateIndex] || null;

    if (nextCandidate) {
      item.imageCandidateIndex = nextCandidateIndex;
      item.image = nextCandidate;
      item.hasValidImage = true;
      item.showImage = true;
      return;
    }

    item.hasValidImage = false;
    item.showImage = false;
    if (item.id != null) {
      this.failedImageIds.add(item.id);
    }
  }

  private precomputeItemFlags(item: ProductCatalogItemVM) {
    item.showImage = !!item.image && item.hasValidImage !== false;
    item.displayPlaceholderToken = item.placeholderToken || item.emoji || '🍽️';
    item.complementsLabel = !item.groupCount ? 'Adicionar' : item.groupCount === 1 ? 'Grupo' : 'Grupos';
  }

  private resolveShowProductPhotosPreference(cardapio: any): boolean {
    const value = cardapio?.exibirFotosProdutosGestao;
    return !(value === false || value === 0 || value === '0');
  }

  private mergeCatalogItems(nextItems: ProductCatalogItemVM[]): ProductCatalogItemVM[] {
    const currentItemsById = new Map<number | null, ProductCatalogItemVM>();
    this.items.forEach((item) => currentItemsById.set(item.id, item));

    return nextItems.map((nextItem) => {
      const currentItem = currentItemsById.get(nextItem.id);
      if (!currentItem) {
        return nextItem;
      }

      Object.assign(currentItem, nextItem);
      return currentItem;
    });
  }

  async toggleStatus(item: ProductCatalogItemVM) {
    this.closeActionSheet();
    try {
      await this.facade.altereStatusProduto(this.empresa, item, item.status !== 'active');
      await this.recarregue();
      this.notificationService.showSuccess('Status do produto atualizado.');
    } catch (error: any) {
      this.notificationService.showError(error?.message || 'Não foi possível atualizar o status.');
    }
  }

  async duplicateItem(item: ProductCatalogItemVM) {
    this.closeActionSheet();
    if (this.duplicatingId != null) return;

    this.duplicatingId = item.id;
    try {
      await this.facade.dupliqueProduto(this.empresa, item);
      await this.recarregue();
      this.notificationService.showSuccess(`"${item.name}" duplicado. A cópia entrou no catálogo com "(Cópia)" no nome.`);
    } catch (error: any) {
      this.notificationService.showError(error?.message || 'Não foi possível duplicar o produto.');
    } finally {
      this.duplicatingId = null;
    }
  }

  async removeItem(item: ProductCatalogItemVM) {
    this.closeActionSheet();
    const ok = await this.confirmacao.confirme(
      'Excluir produto?',
      `"${item.name}" sai do catálogo. Essa ação não pode ser desfeita.`,
      'Excluir'
    );
    if (!ok) return;
    try {
      await this.facade.removaProduto(item);
      await this.recarregue();
      this.notificationService.showSuccess('Produto removido.');
    } catch (error: any) {
      this.notificationService.showError(error?.message || 'Não foi possível remover o produto.');
    }
  }

  async apliqueCategoria(categoria: any) {
    if (!this.moveCategoryItem) return;
    try {
      await this.facade.altereCategoriaProduto(
        this.empresa,
        this.moveCategoryItem,
        this.empresa.catalogo.categorias.find((cat: any) => cat.id === categoria.id)
      );
      this.fecheMoverCategoria();
      await this.recarregue();
      this.notificationService.showSuccess('Categoria atualizada.');
    } catch (error: any) {
      this.notificationService.showError(error?.message || 'Não foi possível alterar a categoria.');
    }
  }

  toggleBulkMode() {
    if (this.isReorderMode) {
      this.notificationService.showError('Finalize a reordenação antes de selecionar produtos em lote.');
      return;
    }

    this.bulkMode = !this.bulkMode;
    if (!this.bulkMode) {
      this.limpeSelecaoLote();
    }
  }

  toggleBulkItem(item: ProductCatalogItemVM, event?: Event) {
    if (event) event.stopPropagation();
    if (item.id == null) return;
    this.bulkSelection[item.id] = !this.bulkSelection[item.id];
  }

  toggleTodosProdutosVisiveis(event?: Event) {
    if (event) event.stopPropagation();
    const selecionar = !this.todosProdutosVisiveisSelecionados;

    this.filteredItems.forEach((item) => {
      if (item.id != null) {
        this.bulkSelection[item.id] = selecionar;
      }
    });
  }

  limpeSelecaoLote() {
    this.bulkSelection = {};
    this.bulkCategoryId = '';
  }

  async bulkPauseActivate(pausar: boolean = this.selectedStatusTab !== 'unavailable') {
    if (this.bulkActionBusy) return;

    if (!this.podeAlterarDisponibilidade) {
      this.notificationService.showError('Você não tem permissão para alterar a disponibilidade.');
      return;
    }

    if (!this.selectedIds.length) {
      this.notificationService.showError('Selecione pelo menos um produto.');
      return;
    }

    this.bulkActionBusy = true;

    try {
      const total = this.selectedIds.length;
      await this.facade.pauseAtiveProdutosLote(this.empresa.catalogo, this.selectedIds, pausar);
      this.limpeSelecaoLote();
      this.bulkMode = false;
      await this.recarregue();
      this.notificationService.showSuccess(total + (pausar ? ' produto(s) pausado(s).' : ' produto(s) despausado(s).'));
    } catch (error: any) {
      this.notificationService.showError(error?.message || 'Não foi possível atualizar os produtos.');
    } finally {
      this.bulkActionBusy = false;
    }
  }

  async bulkDuplicate() {
    if (this.bulkActionBusy) return;

    if (!this.selectedIds.length) {
      this.notificationService.showError('Selecione pelo menos um produto.');
      return;
    }

    this.bulkActionBusy = true;

    try {
      for (const id of this.selectedIds) {
        const item = this.items.find((current) => current.id === id);
        if (item) await this.facade.dupliqueProduto(this.empresa, item);
      }
      this.limpeSelecaoLote();
      this.bulkMode = false;
      await this.recarregue();
      this.notificationService.showSuccess('Produtos duplicados.');
    } catch (error: any) {
      this.notificationService.showError(error?.message || 'Não foi possível duplicar os produtos.');
    } finally {
      this.bulkActionBusy = false;
    }
  }

  async bulkMoveCategory(categoryIdValue: string) {
    if (this.bulkActionBusy) return;
    if (!categoryIdValue) return;

    if (!this.selectedIds.length) {
      this.bulkCategoryId = '';
      this.notificationService.showError('Selecione pelo menos um produto.');
      return;
    }

    const categoryId = categoryIdValue ? Number(categoryIdValue) : null;
    const categoria = categoryId == null
      ? null
      : this.empresa?.catalogo?.categorias?.find((item: any) => item.id === categoryId) || null;

    this.bulkActionBusy = true;

    try {
      for (const id of this.selectedIds) {
        const item = this.items.find((current) => current.id === id);
        if (item) {
          await this.facade.altereCategoriaProduto(this.empresa, item, categoria);
        }
      }
      this.limpeSelecaoLote();
      this.bulkMode = false;
      await this.recarregue();
      this.notificationService.showSuccess('Categoria alterada em lote.');
    } catch (error: any) {
      this.notificationService.showError(error?.message || 'Não foi possível alterar a categoria em lote.');
    } finally {
      this.bulkActionBusy = false;
    }
  }

  abraDisponibilidadeLote() {
    if (this.bulkActionBusy || this.bulkAvailabilitySaving) return;

    if (!this.selectedIds.length) {
      this.notificationService.showError('Selecione pelo menos um produto.');
      return;
    }

    this.abraDialogDisponibilidadeLote('selection');
  }

  abraDisponibilidadeCategoriaSelecionada() {
    if (this.bulkActionBusy || this.bulkAvailabilitySaving) return;

    const categoria = this.categoriaSelecionadaAtual;

    if (!categoria?.id) {
      this.notificationService.showError('Selecione uma categoria para alterar a disponibilidade.');
      return;
    }

    this.abraDialogDisponibilidadeLote('category', categoria);
  }

  private abraDialogDisponibilidadeLote(target: CatalogAvailabilityTargetV2, categoria: { id: number | null; nome: string } | null = null) {
    if (!this.podeAlterarDisponibilidade) {
      this.notificationService.showError('Você não tem permissão para alterar a disponibilidade.');
      return;
    }

    this.bulkAvailabilityTarget = target;
    this.bulkAvailabilityCategory = categoria;
    this.bulkAvailabilityForm = {
      disponibilidade: 0,
      disponibilidades: []
    };
    this.bulkAvailabilityDialogOpen = true;
  }

  fecheDisponibilidadeLote() {
    if (this.bulkAvailabilitySaving) return;
    this.bulkAvailabilityDialogOpen = false;
    this.bulkAvailabilityCategory = null;
    this.bulkAvailabilityForm = { disponibilidade: 0, disponibilidades: [] };
  }

  onBulkAvailabilityChange() {
    if (this.bulkAvailabilityForm.disponibilidade !== 1) {
      this.bulkAvailabilityForm.disponibilidades = [];
    }
  }

  podeSalvarDisponibilidadeLote(): boolean {
    if (this.bulkAvailabilitySaving) return false;
    if (this.bulkAvailabilityTarget === 'selection' && !this.selectedIds.length) return false;
    if (this.bulkAvailabilityTarget === 'category' && !this.bulkAvailabilityCategory?.id) return false;

    if (this.bulkAvailabilityForm.disponibilidade !== 1 || this.disponibilidadePorEmpresa) {
      return true;
    }

    const disponibilidades = this.viewDisponibilidadesV2
      ? this.viewDisponibilidadesV2.disponibilidades
      : this.bulkAvailabilityForm.disponibilidades;

    return disponibilidades && disponibilidades.length > 0;
  }

  get tituloDisponibilidadeLote(): string {
    return this.bulkAvailabilityTarget === 'category'
      ? 'Alterar disponibilidade da categoria'
      : 'Alterar disponibilidade dos selecionados';
  }

  get descricaoAlvoDisponibilidadeLote(): string {
    if (this.bulkAvailabilityTarget === 'category') {
      return this.bulkAvailabilityCategory?.nome || 'Categoria';
    }

    return this.selectedIds.length + ' produto(s)';
  }

  async apliqueDisponibilidadeLote() {
    if (!this.podeSalvarDisponibilidadeLote()) return;

    const payload: any = {
      disponibilidade: this.bulkAvailabilityForm.disponibilidade
    };

    if (this.bulkAvailabilityTarget === 'category') {
      payload.categoriaId = this.bulkAvailabilityCategory!.id;
    } else {
      payload.produtoIds = this.selectedIds;
    }

    if (this.bulkAvailabilityForm.disponibilidade === 1 && !this.disponibilidadePorEmpresa) {
      payload.disponibilidades = this.viewDisponibilidadesV2
        ? this.viewDisponibilidadesV2.disponibilidades
        : this.bulkAvailabilityForm.disponibilidades;
    }

    this.bulkAvailabilitySaving = true;

    try {
      const resposta = await this.facade.salveDisponibilidadeProdutosLote(this.empresa.catalogo, payload);
      this.bulkAvailabilitySaving = false;
      this.fecheDisponibilidadeLote();
      this.limpeSelecaoLote();
      this.bulkMode = false;
      await this.recarregue();
      this.notificationService.showSuccess((resposta?.total || 'Produtos') + ' produto(s) atualizado(s).');
    } catch (error: any) {
      this.notificationService.showError(error?.message || 'Não foi possível alterar a disponibilidade.');
    } finally {
      this.bulkAvailabilitySaving = false;
    }
  }

  abraConfirmacaoRemoverLote() {
    if (this.bulkActionBusy) return;

    if (!this.podeEditarProdutos) {
      this.notificationService.showError('Você não tem permissão para excluir produtos.');
      return;
    }

    if (!this.selectedIds.length) {
      this.notificationService.showError('Selecione pelo menos um produto.');
      return;
    }

    this.bulkDeleteDialogOpen = true;
  }

  fecheConfirmacaoRemoverLote() {
    if (this.bulkActionBusy) return;
    this.bulkDeleteDialogOpen = false;
  }

  async removaProdutosSelecionadosLote() {
    if (this.bulkActionBusy) return;
    if (!this.selectedIds.length || !this.podeEditarProdutos) return;

    this.bulkActionBusy = true;

    try {
      const total = this.selectedIds.length;
      const resposta = await this.facade.removaProdutosLote(this.empresa.catalogo, this.selectedIds);
      this.bulkDeleteDialogOpen = false;
      this.limpeSelecaoLote();
      this.bulkMode = false;
      await this.recarregue();
      this.notificationService.showSuccess((resposta?.total || total) + ' produto(s) removido(s).');
    } catch (error: any) {
      this.notificationService.showError(error?.message || 'Não foi possível remover os produtos selecionados.');
    } finally {
      this.bulkActionBusy = false;
    }
  }

  openLegacyTools() {
    void this.navigateToAdminLegacyProducts();
  }

  abraModalExportarProdutos() {
    this.closeExportDropdown();
    this.fecheExportadores();
    const catalogo = this.empresa?.catalogo;
    if (!catalogo?.id) {
      return false;
    }

    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: ModalExportarProdutosComponent,
      minWidth: 800,
      width: window.innerWidth > 1200 ? 1200 : window.innerWidth,
      maxHeight: window.innerHeight - 100,
      cssClass: 'bsModal'
    });

    windowRef.content.instance.catalogo = catalogo;
    windowRef.content.instance.temEstoque = this.selectedStatusTab === 'sale';

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef);
    windowRef.result.subscribe(() => { });

    return false;
  }

  downloadCardapioPDF() {
    this.closeExportDropdown();
    this.fecheExportadores();
    const catalogoId = this.empresa?.catalogo?.id;
    if (!catalogoId) {
      return;
    }

    window.open(`/images/empresa/pdf/cardapio${catalogoId}.pdf?v=${new Date().getTime()}`, '_BLANK');
  }

  async onDrawerClosed() {
    const closedProductId = this.drawerProductId;
    const shouldRefreshCatalog = this.drawerHasCommittedChanges;
    this.closeProductDrawer();
    if (shouldRefreshCatalog && closedProductId != null) {
      this.failedImageIds.delete(closedProductId);
    }
    if (shouldRefreshCatalog) {
      await this.recarregue({ silent: true });
    }
  }

  async onDrawerProductResolved(productId: number) {
    this.drawerProductId = productId;
    this.drawerNewProductType = null;
    this.drawerOpen = true;
    this.drawerHasCommittedChanges = true;
    await this.updateDrawerQueryParams();
  }

  onDrawerProductPersisted(): void {
    this.drawerHasCommittedChanges = true;
  }

  /** "Salvar e novo": atualiza a lista e reabre o formulário limpo na mesma categoria. */
  async onDrawerProductCreatedForNext(event: { type: ProductTypeV2; categoryId: number | null }) {
    this.drawerHasCommittedChanges = true;
    await this.recarregue({ silent: true });
    this.drawerProductId = null;
    this.drawerNewProductType = event.type;
    this.drawerInitialCategoryId = event.categoryId;
    this.drawerCreationSeed++;
    this.drawerOpen = true;
    await this.updateDrawerQueryParams();
    this.scrollDrawerToTop();
  }

  async onDrawerSurfaceChange(event: {
    surfaceMode: ProductEditorSurfaceV2;
    focusGroupId?: number | string | null;
    groupDraftMode?: ProductEditorGroupDraftModeV2 | null;
    startWithLibrary?: boolean;
    optionMode?: ProductEditorOptionModeV2 | null;
  }) {
    const previousSurface = this.drawerSurface || 'overview';
    if (previousSurface === 'overview' && event.surfaceMode === 'group-detail') {
      this.captureDrawerOverviewScroll();
    }
    const previousFocusGroupId = this.drawerFocusGroupId;
    const previousGroupDraftMode = this.drawerGroupDraftMode;
    const previousStartWithLibrary = this.drawerStartWithLibrary;
    this.drawerSurface = event.surfaceMode || 'overview';
    this.drawerFocusGroupId = event.focusGroupId ?? null;
    this.drawerGroupDraftMode = event.groupDraftMode ?? null;
    this.drawerStartWithLibrary = !!event.startWithLibrary;
    this.drawerOptionMode = event.optionMode ?? null;
    await this.updateDrawerQueryParams();
    if (previousSurface === 'group-detail' && this.drawerSurface === 'overview') {
      this.restoreDrawerScroll(this.drawerOverviewScrollTop);
      return;
    }
    const onlyOptionModeChanged =
      previousSurface === this.drawerSurface &&
      previousFocusGroupId === this.drawerFocusGroupId &&
      previousGroupDraftMode === this.drawerGroupDraftMode &&
      previousStartWithLibrary === this.drawerStartWithLibrary;
    if (!onlyOptionModeChanged) {
      this.scrollDrawerToTop();
    }
  }

  trackByItem(index: number, item: ProductCatalogItemVM) {
    return item.id;
  }

  trackByLabel(index: number, item: any) {
    return item.nome || item.label || item.key || item.title || index;
  }

  private ensureValidFilters() {
    const categoryExists = this.categoryList.find((item) => item.nome === this.selectedCategory);
    if (!categoryExists) {
      this.selectedCategory = 'Todos';
      this.refreshCachedLists();
    }

    this.bulkSelection = {};
  }

  private openProductDrawer(config: {
    productId?: number | null;
    newProductType?: ProductTypeV2 | null;
    initialCategoryId?: number | null;
    surfaceMode?: ProductEditorSurfaceV2;
    focusGroupId?: number | string | null;
    groupDraftMode?: ProductEditorGroupDraftModeV2 | null;
    optionMode?: ProductEditorOptionModeV2 | null;
    startWithPreview?: boolean;
    startWithLibrary?: boolean;
    scrollToSection?: string | null;
  }) {
    this.drawerOpen = true;
    this.drawerProductId = config.productId ?? null;
    this.drawerNewProductType = config.newProductType ?? null;
    this.drawerInitialCategoryId = config.newProductType ? (config.initialCategoryId ?? null) : null;
    this.drawerSurface = config.surfaceMode || 'overview';
    this.drawerFocusGroupId = config.focusGroupId ?? null;
    this.drawerGroupDraftMode = config.groupDraftMode ?? null;
    this.drawerOptionMode = config.optionMode ?? null;
    this.drawerCrossSellProductId = null;
    this.drawerStartWithPreview = !!config.startWithPreview;
    this.drawerStartWithLibrary = !!config.startWithLibrary;
    this.drawerScrollToSection = config.scrollToSection ?? null;
    this.drawerHasCommittedChanges = false;
    this.drawerOverviewScrollTop = 0;
    this.syncViewportLock();
    void this.updateDrawerQueryParams();
    this.scrollDrawerToTop();
  }

  private closeProductDrawer(updateUrl = true) {
    this.drawerOpen = false;
    this.drawerProductId = null;
    this.drawerNewProductType = null;
    this.drawerInitialCategoryId = null;
    this.drawerPizzaTemplateId = null;
    this.drawerSurface = 'overview';
    this.drawerFocusGroupId = null;
    this.drawerGroupDraftMode = null;
    this.drawerOptionMode = null;
    this.drawerCrossSellProductId = null;
    this.drawerStartWithPreview = false;
    this.drawerStartWithLibrary = false;
    this.drawerHasCommittedChanges = false;
    this.drawerScrollToSection = null;
    this.drawerOverviewScrollTop = 0;
    this.syncViewportLock();

    if (updateUrl) {
      void this.updateDrawerQueryParams();
    }
  }

  private syncDrawerFromRoute(params: any) {
    const productId = params['produtoDrawer'] != null ? Number(params['produtoDrawer']) : null;
    const newProductType = (params['novoTipoDrawer'] || null) as ProductTypeV2 | null;
    const initialCategoryId = params['categoriaDrawer'] != null ? Number(params['categoriaDrawer']) : null;
    const surfaceMode = (params['drawerSurface'] || 'overview') as ProductEditorSurfaceV2;
    const focusGroupId = params['drawerGroup'] != null ? params['drawerGroup'] : null;
    const groupDraftMode = (params['drawerGroupMode'] || null) as ProductEditorGroupDraftModeV2 | null;
    const optionMode = (params['drawerOptionsMode'] || null) as ProductEditorOptionModeV2 | null;
    const startWithPreview = params['drawerPreview'] === '1';
    const startWithLibrary = params['drawerLibrary'] === '1';
    const crossSellProductId = params['crossSellProdutoId'] != null ? Number(params['crossSellProdutoId']) : null;
    const scrollToSection = params['drawerTab'] || null;

    if (productId || newProductType) {
      this.drawerOpen = true;
      this.drawerProductId = productId;
      this.drawerNewProductType = newProductType;
      this.drawerInitialCategoryId = newProductType ? initialCategoryId : null;
      this.drawerSurface = surfaceMode;
      this.drawerFocusGroupId = focusGroupId;
      this.drawerGroupDraftMode = groupDraftMode;
      this.drawerOptionMode = optionMode;
      this.drawerCrossSellProductId = crossSellProductId;
      this.drawerStartWithPreview = startWithPreview;
      this.drawerStartWithLibrary = startWithLibrary;
      this.drawerScrollToSection = scrollToSection;
      this.syncViewportLock();
      return;
    }

    this.drawerOpen = false;
    this.drawerProductId = null;
    this.drawerNewProductType = null;
    this.drawerInitialCategoryId = null;
    this.drawerSurface = 'overview';
    this.drawerFocusGroupId = null;
    this.drawerGroupDraftMode = null;
    this.drawerOptionMode = null;
    this.drawerCrossSellProductId = null;
    this.drawerStartWithPreview = false;
    this.drawerStartWithLibrary = false;
    this.drawerScrollToSection = null;
    this.drawerHasCommittedChanges = false;
    this.syncViewportLock();
  }

  private updateDrawerQueryParams() {
    return this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        produtoDrawer: this.drawerProductId ?? null,
        novoTipoDrawer: this.drawerNewProductType ?? null,
        categoriaDrawer: this.drawerOpen && this.drawerNewProductType && this.drawerInitialCategoryId != null ? this.drawerInitialCategoryId : null,
        drawerSurface: this.drawerOpen && this.drawerSurface !== 'overview' ? this.drawerSurface : null,
        drawerGroup: this.drawerOpen && this.drawerFocusGroupId != null ? this.drawerFocusGroupId : null,
        drawerGroupMode: this.drawerOpen && this.drawerGroupDraftMode ? this.drawerGroupDraftMode : null,
        drawerOptionsMode: this.drawerOpen && this.drawerOptionMode ? this.drawerOptionMode : null,
        drawerPreview: this.drawerOpen && this.drawerStartWithPreview ? 1 : null,
        drawerLibrary: this.drawerOpen && this.drawerStartWithLibrary ? 1 : null,
        drawerTab: this.drawerOpen && this.drawerScrollToSection ? this.drawerScrollToSection : null,
        crossSellProdutoId: this.drawerOpen ? this.drawerCrossSellProductId : null,
        origem: this.drawerOpen && this.drawerCrossSellProductId ? 'combinacoes-que-vendem' : null
      },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  get filteredCategoryListInSheet() {
    const term = this.normalizeSearchTerm(this.categorySheetSearch);
    if (!term) return this.categoryList;
    return this.categoryList.filter(cat => this.normalizeSearchTerm(cat.nome).includes(term));
  }

  get visibleCategoryChips() {
    return this.categoryList.slice(0, this.maxVisibleCategoryChips);
  }

  get activeFilterCount(): number {
    let count = 0;
    if (this.appliedFilters.semCodigoPdv) count++;
    if (this.appliedFilters.naoSincronizados) count++;
    if (this.appliedFilters.disponibilidadeIds.length > 0) count++;
    return count;
  }

  get activeFilterChips(): Array<{ label: string; key: string }> {
    const chips: Array<{ label: string; key: string }> = [];
    if (this.appliedFilters.semCodigoPdv) {
      chips.push({ label: 'Sem código PDV', key: 'semCodigoPdv' });
    }
    if (this.appliedFilters.naoSincronizados) {
      chips.push({ label: 'Não sincronizados', key: 'naoSincronizados' });
    }
    if (this.appliedFilters.disponibilidadeIds.length > 0) {
      const names = this.appliedFilters.disponibilidadeIds.map((d: any) => d.descricao).join(', ');
      chips.push({ label: names || 'Disponibilidade', key: 'disponibilidade' });
    }
    return chips;
  }

  abraFiltrosAvancados() {
    this.filterDraft = { ...this.appliedFilters, disponibilidadeIds: [...this.appliedFilters.disponibilidadeIds] };
    this.advancedFiltersOpen = true;
    this.syncViewportLock();
  }

  fecheFiltrosAvancados() {
    this.advancedFiltersOpen = false;
    this.syncViewportLock();
  }

  apliqueFiltrosAvancados() {
    this.appliedFilters = { ...this.filterDraft, disponibilidadeIds: [...this.filterDraft.disponibilidadeIds] };
    this.advancedFiltersOpen = false;
    this.syncViewportLock();
    this.refreshCachedLists();
  }

  limpeFiltrosAvancados() {
    this.filterDraft = {
      sortField: 'ordem',
      sortDirection: 'asc',
      semCodigoPdv: false,
      naoSincronizados: false,
      disponibilidadeIds: []
    };
  }

  removaChipFiltro(key: string) {
    if (key === 'semCodigoPdv') this.appliedFilters.semCodigoPdv = false;
    if (key === 'naoSincronizados') this.appliedFilters.naoSincronizados = false;
    if (key === 'disponibilidade') this.appliedFilters.disponibilidadeIds = [];
    this.refreshCachedLists();
  }


  onMobileReorderTap() {
    if (this.selectedCategory !== 'Todos') {
      this.reorderByCategory(this.selectedCategory);
    } else {
      this.reorderFromSheet = true;
      this.abraCategoriaSheet();
    }
  }

  abraCategoriaSheet() {
    this.categorySheetOpen = true;
    this.categorySheetSearch = '';
    this.categorySheetSelected = this.selectedCategory;
    this.syncViewportLock();
  }

  fecheCategoriaSheet() {
    this.categorySheetOpen = false;
    this.categorySheetSearch = '';
    this.reorderFromSheet = false;
    this.syncViewportLock();
  }

  apliqueCategoriaSheet() {
    const categoria = this.categorySheetSelected;
    const isReorder = this.reorderFromSheet;
    this.reorderFromSheet = false;
    this.fecheCategoriaSheet();

    if (isReorder && categoria !== 'Todos') {
      this.reorderByCategory(categoria);
    } else {
      this.selectedCategory = categoria;
      this.refreshCachedLists();
    }
  }

  limparCategoriaSheet() {
    this.categorySheetSelected = 'Todos';
  }

  toggleSortDirection() {
    this.appliedFilters.sortDirection = this.appliedFilters.sortDirection === 'asc' ? 'desc' : 'asc';
    this.refreshCachedLists();
  }

  private async navigateToAdminLegacyProducts() {
    return this.navigateWithFeedback(
      ['/admin/produtos'],
      {},
      'Não foi possível abrir a tela legada de produtos.'
    );
  }

  private async navigateWithFeedback(commands: any[], extras: any, errorMessage: string): Promise<boolean> {
    try {
      const navigated = await this.router.navigate(commands, extras);
      if (!navigated) {
        this.notificationService.showError(errorMessage);
      }
      return navigated;
    } catch (error: any) {
      this.notificationService.showError(error?.message || errorMessage);
      return false;
    }
  }

  private resolveCategoryEmoji(categoryName: string): string {
    const text = String(categoryName || '').toLowerCase();
    if (text.includes('acai') || text.includes('aça')) return '🍇';
    if (text.includes('burger') || text.includes('hamb')) return '🍔';
    if (text.includes('pizza')) return '🍕';
    if (text.includes('bebida') || text.includes('suco') || text.includes('refri')) return '🥤';
    if (text.includes('combo')) return '🎉';
    return '🍽️';
  }

  private parseMoney(value: string): number {
    const normalized = String(value || '0').replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.');
    const number = Number(normalized);
    return Number.isFinite(number) ? number : 0;
  }

  private formatMoneyInput(value: number): string {
    return Number(value || 0).toFixed(2).replace('.', ',');
  }

  private normalizeSearchTerm(value: string | number | null | undefined): string {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  }

  private matchesPriceSearch(value: number, term: string): boolean {
    const amount = Number(value || 0);
    const rawTerm = String(term || '').trim();
    if (!rawTerm) {
      return true;
    }

    const formattedComma = amount.toFixed(2).replace('.', ',');
    const formattedDot = amount.toFixed(2);
    const integer = String(Math.round(amount * 100));
    const digitsTerm = rawTerm.replace(/[^\d]/g, '');

    return (
      formattedComma.includes(rawTerm)
      || formattedDot.includes(rawTerm)
      || (!!digitsTerm && integer.includes(digitsTerm))
    );
  }

  private canImportFromAnotherStore(): boolean {
    return !!this.getNomeRede() && !this.empresa?.catalogo?.compartilhado && !!this.usuario?.admin;
  }

  private canSyncCatalogModel(): boolean {
    return !!this.empresa?.modeloCatalogoDaRede;
  }

  private canImportOpenDelivery(): boolean {
    return !!this.empresa?.integracaoOpendelivery?.ativa;
  }

  private canSyncWithPartners(): boolean {
    const sistema = this.empresa?.integracaoDelivery?.sistema;
    return sistema === 'ecletica' || sistema === 'bluesoft' || sistema === 'gcom' || sistema === 'totvs';
  }

  private canImportChinaInBox(): boolean {
    return !!(this.usuario?.admin || this.usuario?.superadmin);
  }

  private canImportGendai(): boolean {
    const integracao = this.empresa?.integracaoDelivery;
    return this.canSyncWithPartners() && !!integracao?.unidadeGendai;
  }

  private canImportIfood(): boolean {
    const integracoes = Array.isArray(this.empresa?.integracoesIfood) ? this.empresa.integracoesIfood : [];
    return integracoes.some((integracao: any) => !integracao.desativado);
  }

  private canImportFood99(): boolean {
    const integracoes = Array.isArray(this.empresa?.integracoes99Food) ? this.empresa.integracoes99Food : [];
    return integracoes.some((integracao: any) => !integracao.desativado);
  }

  private getPartnerSystemLabel(): string {
    return String(this.empresa?.integracaoDelivery?.sistema || 'parceiro').toUpperCase();
  }

  private getNomeRede(): string {
    if (this.empresa?.grupoDaLoja?.nome) {
      return String(this.empresa.grupoDaLoja.nome).toUpperCase();
    }

    if (this.empresa?.rede) {
      return String(this.empresa.rede).toUpperCase();
    }

    return '';
  }

  private openLegacyImportModal(config: {
    content: any;
    width: number;
    maxHeight?: number;
    cssClass?: string;
    setup?: (instance: any) => void;
    shouldRefresh?: (result: any) => boolean;
  }) {
    const windowRef = this.dialogService.open({
      title: null,
      content: config.content,
      minWidth: 250,
      width: window.innerWidth > config.width ? config.width : window.innerWidth,
      maxHeight: config.maxHeight || window.innerHeight - 100,
      cssClass: config.cssClass || 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef);
    config.setup?.(windowRef.content.instance);

    windowRef.result.subscribe((result: any) => {
      const shouldRefresh = config.shouldRefresh ? config.shouldRefresh(result) : !!result;
      if (shouldRefresh) {
        void this.recarregue();
      }
    });
  }

  private abrirImportadorCodigosPdv() {
    const windowRef = this.dialogService.open({
      title: null,
      content: ImportadorCodigosPdvV2Component,
      minWidth: 360,
      width: window.innerWidth > 1080 ? 1080 : window.innerWidth - 24,
      maxHeight: window.innerHeight - 80,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef);

    if (windowRef.content?.instance?.inicialize) {
      windowRef.content.instance.inicialize(windowRef);
    }

    windowRef.content.instance.empresa = this.empresa;
    windowRef.content.instance.catalogItems = this.items;

    windowRef.result.subscribe((result: any) => {
      if (result?.updated) {
        void this.recarregue({ silent: true });
      }
    });
  }

  private importarProdutoCodigoERP() {
    this.openLegacyImportModal({
      content: TelaImportarProdutosERPComponent,
      width: 800,
      setup: (instance) => {
        instance.informarCodigo = true;
        instance.empresa = this.empresa;
      },
      shouldRefresh: (result) => !!result?.importou
    });
  }

  private importarOpenDelivery() {
    this.importarProdutosERP(true);
  }

  private importarProdutosERP(openDelivery = false) {
    this.openLegacyImportModal({
      content: TelaImportarProdutosERPComponent,
      width: 900,
      setup: (instance) => {
        instance.catalogo = this.empresa?.catalogo;
        if (openDelivery) {
          instance.openDelivery = true;
        }
      }
    });
  }

  private abrirImportarCatalogoEmpresaRede() {
    this.openLegacyImportModal({
      content: TelaImportarCatalogoEmpresaComponent,
      width: 900,
      setup: (instance) => {
        instance.empresa = this.empresa;
      }
    });
  }

  private importarProdutosCatalogoModelo() {
    this.openLegacyImportModal({
      content: TelaSincronizarCatalogomodeloComponent,
      width: 900,
      setup: (instance) => {
        instance.empresa = this.empresa;
      }
    });
  }

  private importarProdutosChinaInBox() {
    this.openLegacyImportModal({
      content: TelaSincronizarChinaComponent,
      width: 800,
      setup: (instance) => {
        instance.empresa = this.empresa;
        instance.forcarChinaInBox = true;
        instance.carregueLojasChinaInBox();
      }
    });
  }

  private importarProdutosChinna() {
    this.openLegacyImportModal({
      content: TelaSincronizarChinaComponent,
      width: 800,
      setup: (instance) => {
        instance.empresa = this.empresa;
      }
    });
  }

  private importarDeSistemaExterno() {
    this.openLegacyImportModal({
      content: TelaSincronizarIfoodComponent,
      width: 900,
      setup: (instance) => {
        instance.sistemaExterno = true;
        instance.catalogo = this.empresa?.catalogo;
      }
    });
  }

  private importarDoIfoodOficial() {
    this.openLegacyImportModal({
      content: TelaSincronizarIfoodComponent,
      width: 900,
      setup: (instance) => {
        instance.ifoodOficial = true;
        instance.catalogo = this.empresa?.catalogo;
        instance.empresa = this.empresa;
      }
    });
  }

  private importarDoFood99Oficial() {
    this.openLegacyImportModal({
      content: TelaSincronizarIfoodComponent,
      width: 900,
      setup: (instance) => {
        instance.food99Oficial = true;
        instance.catalogo = this.empresa?.catalogo;
        instance.empresa = this.empresa;
      }
    });
  }

  private importarDeArquivoPrecosCSV() {
    this.openLegacyImportModal({
      content: ImportadorCsvComponent,
      width: 1400,
      maxHeight: window.innerHeight - 32,
      cssClass: 'bsModal importadorCsvDialog',
      setup: (instance) => {
        instance.empresa = this.empresa;
        instance.catalogo = this.empresa?.catalogo;
        instance.somentePrecos = true;
      }
    });
  }

  private importarDeArquivoCSV() {
    this.openLegacyImportModal({
      content: ImportadorCsvComponent,
      width: 1400,
      maxHeight: window.innerHeight - 32,
      cssClass: 'bsModal importadorCsvDialog',
      setup: (instance) => {
        instance.empresa = this.empresa;
      }
    });
  }

  private syncViewportLock() {
    const hasBlockingPanel = (
      this.drawerOpen
      || this.actionSheetOpen
      || !!this.moveCategoryItem
      || this.createChooserOpen
      || this.importChooserOpen
      || this.exportChooserOpen
      || this.moreActionsOpen
      || this.categorySheetOpen
      || this.advancedFiltersOpen
    );

    document.body.classList.toggle(TelaCatalogoProdutosV2Component.BODY_DRAWER_CLASS, hasBlockingPanel);
  }

  private scrollDrawerToTop() {
    requestAnimationFrame(() => {
      const drawer = this.getDrawerElement();
      if (drawer) drawer.scrollTop = 0;
    });
  }

  private captureDrawerOverviewScroll() {
    const drawer = this.getDrawerElement();
    if (drawer) {
      this.drawerOverviewScrollTop = drawer.scrollTop;
    }
  }

  private restoreDrawerScroll(position: number) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const drawer = this.getDrawerElement();
        if (drawer) {
          drawer.scrollTop = position;
        }
      });
    });
  }

  private getDrawerElement(): HTMLElement | null {
    return document.querySelector('.pv2-editor-drawer') as HTMLElement | null;
  }

  // ========== MÉTODOS DE ORDENAÇÃO ==========

  private viewModeBeforeReorder: ProductCatalogViewModeV2 = 'grid';
  private categoryBeforeReorder: string = 'Todos';

  reorderByCategory(categoryName: string) {
    this.bulkMode = false;
    this.limpeSelecaoLote();
    this.viewModeBeforeReorder = this.viewMode;
    this.categoryBeforeReorder = this.selectedCategory;
    this.selectedCategory = categoryName;
    this.refreshCachedLists();
    this.viewMode = 'list';
    this.isReorderMode = true;
    this.reorderDraft = [...this.filteredItems];
    this.notificationService.showInfo(`Reordenando produtos da categoria "${categoryName}".`);
  }

  enterReorderMode() {
    this.reorderByCategory(this.selectedCategory);
  }

  exitReorderMode(save: boolean = false) {
    if (save && this.hasReorderChanges()) {
      this.saveReorder();
    } else {
      this.reorderDraft = [];
    }
    this.isReorderMode = false;
    this.viewMode = this.viewModeBeforeReorder;
    this.selectedCategory = this.categoryBeforeReorder;
    this.refreshCachedLists();
  }

  hasReorderChanges(): boolean {
    if (this.reorderDraft.length !== this.filteredItems.length) return true;

    return this.reorderDraft.some((item, index) =>
      item.id !== this.filteredItems[index]?.id
    );
  }

  async saveReorder() {
    if (!this.hasReorderChanges()) return;

    try {
      const ordenacao = this.reorderDraft.map((item, index) => ({
        id: item.id!,
        ordem: index + 1
      }));

      await this.facade.reordenarMultiplosProdutos(
        this.empresa.id,
        ordenacao
      );

      this.reorderDraft.forEach((item, index) => {
        item.ordem_exibicao = index + 1;
      });
      this.filteredItems = [...this.reorderDraft];
      this.notificationService.showSuccess('Ordem dos produtos salva com sucesso');
      this.isReorderMode = false;
      this.reorderDraft = [];
      this.viewMode = this.viewModeBeforeReorder;
      this.selectedCategory = this.categoryBeforeReorder;
      this.refreshCachedLists();
    } catch (error: any) {
      this.notificationService.showError('Erro ao salvar ordem: ' + (error?.message || 'Tente novamente'));
    }
  }

  private flashMoved(moved: ProductCatalogItemVM, swapped?: ProductCatalogItemVM, direction?: 'up' | 'down') {
    clearTimeout(this.lastMovedTimer);
    this.lastMovedIds = new Set<number>();
    this.lastSwappedId = null;
    this.lastMoveDirection = null;

    setTimeout(() => {
      this.lastMovedIds = new Set([moved.id!]);
      this.lastMoveDirection = direction || null;
      if (swapped) {
        this.lastMovedIds.add(swapped.id!);
        this.lastSwappedId = swapped.id!;
      }
      this.lastMovedTimer = setTimeout(() => {
        this.lastMovedIds = new Set<number>();
        this.lastSwappedId = null;
        this.lastMoveDirection = null;
      }, 1200);
    });
  }

  // Métodos de movimentação individual
  moveProductUp(item: ProductCatalogItemVM) {
    const items = this.isReorderMode ? this.reorderDraft : this.filteredItems;
    const index = items.indexOf(item);

    if (index > 0) {
      const swapped = items[index - 1];
      [items[index], items[index - 1]] = [items[index - 1], items[index]];
      this.flashMoved(item, swapped, 'up');

      if (this.isReorderMode) {
        this.reorderDraft = [...this.reorderDraft];
      } else {
        this.saveReorderDebounced();
      }
    }
  }

  moveProductDown(item: ProductCatalogItemVM) {
    const items = this.isReorderMode ? this.reorderDraft : this.filteredItems;
    const index = items.indexOf(item);

    if (index < items.length - 1) {
      const swapped = items[index + 1];
      [items[index], items[index + 1]] = [items[index + 1], items[index]];
      this.flashMoved(item, swapped, 'down');

      if (this.isReorderMode) {
        this.reorderDraft = [...this.reorderDraft];
      } else {
        this.saveReorderDebounced();
      }
    }
  }

  moveProductToTop(item: ProductCatalogItemVM) {
    const items = this.isReorderMode ? this.reorderDraft : this.filteredItems;
    const index = items.indexOf(item);

    if (index > 0) {
      items.splice(index, 1);
      items.unshift(item);
      this.flashMoved(item, undefined, 'up');

      if (this.isReorderMode) {
        this.reorderDraft = [...this.reorderDraft];
      } else {
        this.saveReorderDebounced();
      }
    }
  }

  moveProductToBottom(item: ProductCatalogItemVM) {
    const items = this.isReorderMode ? this.reorderDraft : this.filteredItems;
    const index = items.indexOf(item);

    if (index < items.length - 1) {
      items.splice(index, 1);
      items.push(item);
      this.flashMoved(item, undefined, 'down');

      if (this.isReorderMode) {
        this.reorderDraft = [...this.reorderDraft];
      } else {
        this.saveReorderDebounced();
      }
    }
  }

  // Debounce para salvar automaticamente
  private saveReorderDebounced = this.debounce(async () => {
    try {
      const ordenacao = this.filteredItems.map((item, index) => ({
        id: item.id!,
        ordem: index + 1
      }));

      await this.facade.reordenarMultiplosProdutos(
        this.empresa.id,
        ordenacao
      );
    } catch (error) {
      console.error('Erro ao salvar ordem:', error);
    }
  }, 1000);

  private debounce(func: Function, wait: number) {
    let timeout: any;
    return (...args: any[]) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  // Ordenação automática para grid
  applyGridSort() {
    const sorted = [...this.filteredItems];

    switch (this.gridSortField) {
      case 'name':
        sorted.sort((a, b) => {
          const compare = a.name.localeCompare(b.name, 'pt-BR');
          return this.gridSortDirection === 'asc' ? compare : -compare;
        });
        break;

      case 'price':
        sorted.sort((a, b) => {
          const diff = a.basePrice - b.basePrice;
          return this.gridSortDirection === 'asc' ? diff : -diff;
        });
        break;

      case 'created':
        sorted.sort((a, b) => {
          const aDate = new Date(a.raw?.created_at || 0).getTime();
          const bDate = new Date(b.raw?.created_at || 0).getTime();
          const diff = aDate - bDate;
          return this.gridSortDirection === 'asc' ? diff : -diff;
        });
        break;
    }

    this.filteredItems = sorted;
  }

  toggleGridSortDirection() {
    this.gridSortDirection = this.gridSortDirection === 'asc' ? 'desc' : 'asc';
    this.applyGridSort();
  }

  onSortChipClick(value: string) {
    if (this.gridSortField === value) {
      this.toggleGridSortDirection();
    } else {
      this.gridSortField = value as CatalogSortFieldV2;
      this.applyGridSort();
    }
  }

  canReorder(item: ProductCatalogItemVM): boolean {
    return this.isReorderMode && this.viewMode === 'list' && !this.isMobile;
  }

  get displayItems(): ProductCatalogItemVM[] {
    return this.isReorderMode ? this.reorderDraft : this.filteredItems;
  }

  getReorderItems(): ProductCatalogItemVM[] {
    return this.isReorderMode ? this.reorderDraft : this.filteredItems;
  }

  getReorderIndex(item: ProductCatalogItemVM): number {
    const items = this.getReorderItems();
    return items.indexOf(item) + 1;
  }
}
